if not App.angularApp?
    return

# mfFixedHeader fixed header scrollable table directive
# Based on:
# * AngularJS fixed header scrollable table directive
# * @author Jason Watmore <jason@pointblankdevelopment.com.au> (http://jasonwatmore.com)
# * @version 1.0.0

App.angularApp.directive 'mfFixedHeader', ['$timeout', '$window', ($timeout, $window) ->
    return {
        restrict: 'A',
        link:
            pre: ($scope, $elem, $attrs, $ctrl) =>
                undefined

            post: ($scope, $elem, $attrs, $ctrl) =>
                fixIt = () =>
                    # Wrap in $timeout to give table a chance to finish rendering
                    $timeout () =>
                        # Reset display styles so column widths are correct when measured below
                        $elem.find('thead, tfoot, tbody').css 'display', ''
                        $elem.find('th, td').css 'width', ''

                        # Explicitly set the width of every cell according to what the browser decides is best
                        # This needs to be two separate loops because if you try setting the width of the cells
                        # one at a time, then it rerenders the table, causing the widths of the remaining cells
                        # to get off. By setting the widths on mf-width data attribute, we are saving all the
                        # widths before changing any of them.
                        $elem.find('th, td').each (i, elem) =>
                            $(elem).data 'mf-width', $(elem).width()

                        $elem.find('th, td').each (i, elem) =>
                            $(elem).width $(elem).data('mf-width')
                            $(elem).data 'mf-width', null

                        # Set css styles on thead and tbody to allow for tbody scrolling based on height
                        $elem.find('thead').css
                            display: 'block'

                        $elem.find('tfoot').css
                            display: 'block'

                        $elem.find('tbody').css
                            display: 'block'
                            overflow: 'auto'

                        # Account For Scrollbar
                        if $elem.find('tbody')[0].scrollHeight isnt $elem.find('tbody')[0].clientHeight
                            scrollBarWidth = $elem.find('thead').width() - $elem.find('tbody')[0].clientWidth

                            widths = []
                            $elem.find('thead th:last-child, thead td:last-child').each (i, cell) =>
                                widths[i] = $(cell).width()

                            $elem.find('thead th:last-child, thead td:last-child').each (i, cell) =>
                                cell = $(cell)
                                cell.width widths[i] + scrollBarWidth

                # Obviously, fix the table sizing if the window is resized
                angular.element($window).bind 'resize', debounce fixIt

                # this watcher was causing compounded results b/c the digest runs multiple times
                # now we only call fixIt if the visiblity has changed
                #@previouslyVisible = $elem.find('tbody').is(':visible')
                #$scope.$watch(
                #    () =>
                #        return $elem.find('tbody').is(':visible') isnt @previouslyVisible
                #    , (resize) =>
                #        if resize
                #            @previouslyVisible = $elem.find('tbody').is(':visible')
                #            fixIt()
                #)

                if $attrs?.mfFixedHeader
                    $scope.$watch $attrs.mfFixedHeader, fixIt
    }
]
